import { useFormikContext } from "formik";
import { ACTION_STATUS } from "../../../../constants/actions";
import OtherActionPerformed from "./OtherActionPerformed";
import OtherActionSuggestion from "./OtherActionSuggestion";
import { ACTION_VIEW_MODE } from "../../../../constants/action-form";
import checkIfPerformedWithSuggested from "components/action-modal/utils/checkIfPerformedWithSuggested";

const OtherActionDetails = ({ viewMode, status, isNewVersion }) => {
  const { values } = useFormikContext();
  const isPerformedWithSuggested = checkIfPerformedWithSuggested(values);

  if (
    viewMode === ACTION_VIEW_MODE.view ||
    viewMode === ACTION_VIEW_MODE.edit
  ) {
    if (status !== ACTION_STATUS.performed) {
      return <OtherActionSuggestion viewMode={viewMode} isFullWidth />;
    } else if (isPerformedWithSuggested) {
      return (
        <div className="action-details-both-box-wrapper">
          <OtherActionSuggestion
            viewMode={ACTION_VIEW_MODE.view}
            isProposedValue
          />
          <OtherActionPerformed viewMode={viewMode} />
        </div>
      );
    } else {
      return <OtherActionPerformed viewMode={viewMode} isFullWidth />;
    }
  } else if (viewMode === ACTION_VIEW_MODE.new) {
    if (status !== ACTION_STATUS.performed) {
      return <OtherActionSuggestion viewMode={viewMode} isFullWidth isNewVersion={isNewVersion} />;
    } else {
      return <OtherActionPerformed viewMode={viewMode} isFullWidth isNewVersion={isNewVersion} />;
    }
  } else {
    return <></>;
  }
};

export default OtherActionDetails;
